module.exports = __webpack_public_path__ + "img/help.6e93aaa7.png";